import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { getClient, showReportDialog, withScope } from '@sentry/browser';
import { logger } from '@sentry/core';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';
import { DEBUG_BUILD } from './debug-build.js';
import { captureReactException } from './error.js';
var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
  componentStack: null,
  error: null,
  eventId: null
};

/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    ErrorBoundary.prototype.__init.call(_assertThisInitialized(_this));
    _this.state = INITIAL_STATE;
    _this._openFallbackReportDialog = true;
    var client = getClient();
    if (client && props.showDialog) {
      _this._openFallbackReportDialog = false;
      _this._cleanupHook = client.on('afterSendEvent', function (event) {
        if (!event.type && _this._lastEventId && event.event_id === _this._lastEventId) {
          showReportDialog(_objectSpread(_objectSpread({}, props.dialogOptions), {}, {
            eventId: _this._lastEventId
          }));
        }
      });
    }
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this2 = this;
      var componentStack = errorInfo.componentStack;
      // TODO(v9): Remove this check and type `componentStack` to be React.ErrorInfo['componentStack'].
      var passedInComponentStack = componentStack == null ? undefined : componentStack;
      var _this$props = this.props,
        beforeCapture = _this$props.beforeCapture,
        onError = _this$props.onError,
        showDialog = _this$props.showDialog,
        dialogOptions = _this$props.dialogOptions;
      withScope(function (scope) {
        if (beforeCapture) {
          beforeCapture(scope, error, passedInComponentStack);
        }
        var handled = _this2.props.handled != null ? _this2.props.handled : !!_this2.props.fallback;
        var eventId = captureReactException(error, errorInfo, {
          mechanism: {
            handled: handled
          }
        });
        if (onError) {
          onError(error, passedInComponentStack, eventId);
        }
        if (showDialog) {
          _this2._lastEventId = eventId;
          if (_this2._openFallbackReportDialog) {
            showReportDialog(_objectSpread(_objectSpread({}, dialogOptions), {}, {
              eventId: eventId
            }));
          }
        }

        // componentDidCatch is used over getDerivedStateFromError
        // so that componentStack is accessible through state.
        _this2.setState({
          error: error,
          componentStack: componentStack,
          eventId: eventId
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;
      if (onMount) {
        onMount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state = this.state,
        error = _this$state.error,
        componentStack = _this$state.componentStack,
        eventId = _this$state.eventId;
      var onUnmount = this.props.onUnmount;
      if (onUnmount) {
        onUnmount(error, componentStack, eventId);
      }
      if (this._cleanupHook) {
        this._cleanupHook();
        this._cleanupHook = undefined;
      }
    }
  }, {
    key: "__init",
    value: function __init() {
      var _this3 = this;
      this.resetErrorBoundary = function () {
        var onReset = _this3.props.onReset;
        var _this3$state = _this3.state,
          error = _this3$state.error,
          componentStack = _this3$state.componentStack,
          eventId = _this3$state.eventId;
        if (onReset) {
          onReset(error, componentStack, eventId);
        }
        _this3.setState(INITIAL_STATE);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        fallback = _this$props2.fallback,
        children = _this$props2.children;
      var state = this.state;
      if (state.error) {
        var element = undefined;
        if (typeof fallback === 'function') {
          element = /*#__PURE__*/React.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: this.resetErrorBoundary,
            eventId: state.eventId
          });
        } else {
          element = fallback;
        }
        if ( /*#__PURE__*/React.isValidElement(element)) {
          return element;
        }
        if (fallback) {
          DEBUG_BUILD && logger.warn('fallback did not produce a valid ReactElement');
        }

        // Fail gracefully if no fallback provided or is not valid
        return null;
      }
      if (typeof children === 'function') {
        return children();
      }
      return children;
    }
  }]);
  return ErrorBoundary;
}(React.Component); // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
  var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
  var Wrapped = function Wrapped(props) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, _objectSpread({}, errorBoundaryOptions), /*#__PURE__*/React.createElement(WrappedComponent, _objectSpread({}, props)));
  };
  Wrapped.displayName = "errorBoundary(".concat(componentDisplayName, ")");

  // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}
export { ErrorBoundary, UNKNOWN_COMPONENT, withErrorBoundary };